/**
 * Styled Components - Created by david on 13/02/18.
 */
import styled from 'styled-components'
import AntDivider from 'antd/lib/divider'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin-right: -14px;
  padding: 0px 0px 0px 16px;
  transition: all .25s;
`

export const LoadingContainer = styled.div`
  height: 22.67em;
  margin: -12px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
`

interface FilterProps {
  width?: string
}

export const Filters = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: fit-content;
  padding-right: 12px;
  transition: all .25s;
  max-width: ${({ width }: FilterProps) => width};
`

export const Categories = styled.div`
  padding-left: 16px;
  width: fit-content;
  padding-right: 16px;
  max-width: 20%;
  min-width: 170px;
  transition: all .25s;
`

export const Divider = styled(AntDivider)`
  height: 22.67em;
  margin: -12px 0px;
`

export const Divider2 = styled(AntDivider)`
  height: calc(100% + 18px);
  margin: -12px 0px;
  margin-right: 12px;
  margin-left: -10px;
`

export const EvoDiv = styled.div`
  max-width: 100%;
  flex: 1;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  transition: all .25s;
  &:hover {
    opacity: 0.8;
    cursor: pointer;
  }
`

export const EvoLogo = styled.img`
  max-width: 110px;
  opacity: 0.8;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/MenuSports/styledComponents.tsx